import api from '@/lib/axios';

export const creditNotesService = {
  async findByCustomer(customerId: string) {
    const response = await api.get(`/credit-notes/customer/${customerId}`);
    return response.data;
  },

  async getAvailableCredit(customerId: string) {
    const response = await api.get(`/credit-notes/customer/${customerId}/available`);
    return response.data;
  },

  async findByFolio(folio: string, companyId: string) {
    const response = await api.get(`/credit-notes/folio/${folio}`, { params: { companyId } });
    return response.data;
  },

  async findAll(params: {
    companyId: string;
    customerId?: string;
    status?: string;
    page?: number;
    limit?: number;
    startDate?: string;
    endDate?: string;
  }) {
    const response = await api.get('/credit-notes', { params });
    return response.data;
  },

  async findById(id: string) {
    const response = await api.get(`/credit-notes/${id}`);
    return response.data;
  },

  async useCreditNote(id: string, amount: number) {
    const response = await api.patch(`/credit-notes/${id}/use`, { amount });
    return response.data;
  },
};
